import TrainingsStandard from './src/main';

/* istanbul ignore next */
TrainingsStandard.install = function(Vue) {
  Vue.component(TrainingsStandard.name, TrainingsStandard);
};

export default TrainingsStandard;
